import { useCallback, useState, useEffect } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import { SOLUTION_STORE_SEARCH_COMPLETED } from "/constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import SearchIcon from "monday-ui-react-core/dist/icons/Search";
import CloseSmall from "monday-ui-react-core/dist/icons/CloseSmall";
import dynamic from "next/dynamic";
import MenuComponent from "./menu-component/menu-component";
import { componentStyles } from "./navigation-component.scss";

const Search = dynamic(() => import("monday-ui-react-core/dist/Search"), {
  ssr: false
});

const TemplatesNavigation = (props) => {
  const { onSearchChange, searchTerm, translate, allCategories, selectedCategoryId } = props;

  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const onSearchBlur = useCallback((e) => {
    trackEvent(SOLUTION_STORE_SEARCH_COMPLETED, { kind: e?.target?.value });
  }, []);

  return (
    <div className="navigation-component">
      {isLoaded && (
        <>
          <div className="search-wrapper">
            <Search
              placeholder={translate("templateCenter.template.search")}
              onChange={onSearchChange}
              value={searchTerm}
              iconName={SearchIcon}
              secondaryIconName={CloseSmall}
              onBlur={onSearchBlur}
            />
          </div>
          <div className="category-list-wrapper">
            <MenuComponent allCategories={allCategories} selectedCategoryId={selectedCategoryId} />
          </div>
        </>
      )}

      <style jsx>{componentStyles}</style>
    </div>
  );
};

TemplatesNavigation.defaultProps = {
  onSearchChange: () => {}
};

export default withGenericConfig(TemplatesNavigation);
